import { CustomerDetails } from "../flows-fi-renewal-product-select-section/flows-fi-renewal-product-select-section.model";

import { FlowsFiRenewalContactSectionModel } from "./flows-fi-renewal-contact-section.model";

export namespace FlowsFiRenewalContactSectionAction {
  export class Fetch {
    static readonly type = "[FlowsFiRenewalContactSection] Fetch";
    constructor(public customerDetails: CustomerDetails) {}
  }
  export class Focused {
    static readonly type = "[FlowsFiRenewalContactSection] Focused";
    constructor(public payload: FlowsFiRenewalContactSectionModel) {}
  }
  export class Validated {
    static readonly type = "[FlowsFiRenewalContactSection] Validated";
    constructor(public strongIdentificationURL: string) {}
  }
  export class Disabled {
    static readonly type = "[FlowsFiRenewalContactSection] Disabled";
  }
  export class Completed {
    static readonly type = "[FlowsFiRenewalContactSection] Completed";
    constructor(public payload: FlowsFiRenewalContactSectionModel) {}
  }
  export class Loading {
    static readonly type = "[FlowsFiRenewalContactSection] Loading";
  }
  export class Errorred {
    static readonly type = "[FlowsFiRenewalContactSection] Errorred";
  }

  export class Unauthorized {
    static readonly type = "[FlowsFiRenewalContactSection] Unauthorized";
  }
  export class Default {
    static readonly type = "[FlowsFiRenewalContactSection] Default";
  }
}
